/**
 * Utility to format image URLs for rendering in the Admin Panel.
 * Converts legacy/hardcoded localhost URLs (e.g. http://localhost:3047/uploads/...)
 * or relative paths to proper active service API URLs.
 */
export const getImageUrl = (url, serviceApiUrl) => {
  if (!url || typeof url !== 'string') {
    return "https://placehold.co/600x400?text=No+Image";
  }

  // 1. If it's a blob URL (for local preview before saving) or data:image base64, return as is
  if (url.startsWith("blob:") || url.startsWith("data:")) {
    return url;
  }

  // Clean trailing slashes from serviceApiUrl if present (e.g. "https://api.domain.org/photo-gallery")
  const cleanApiUrl = serviceApiUrl ? serviceApiUrl.replace(/\/$/, '') : '';

  // 2. Handle legacy saved localhost URLs (e.g. http://localhost:3047/uploads/filename.jpg)
  if (url.includes("localhost:3047") || url.includes("localhost:3048") || url.includes("localhost:3059") || url.includes("localhost:3000")) {
    const filename = url.split("/uploads/")[1];
    if (filename && cleanApiUrl) {
      return `${cleanApiUrl}/uploads/${filename}`;
    }
  }

  // 3. Handle service-relative or root-relative paths
  if (url.startsWith("/")) {
    if (url.includes("/uploads/")) {
      const filename = url.split("/uploads/")[1];
      if (filename && cleanApiUrl) {
        return `${cleanApiUrl}/uploads/${filename}`;
      }
    }
    return cleanApiUrl ? `${cleanApiUrl}${url}` : url;
  }

  // 4. Return standard full URLs (e.g. Cloudinary, Azure, or HTTPS URLs)
  return url;
};

export const handleImageError = (e, fallbackText = "No Image") => {
  if (e && e.target) {
    e.target.onerror = null; // Prevent infinite loop if fallback also fails
    e.target.src = `https://placehold.co/600x400?text=${encodeURIComponent(fallbackText)}`;
  }
};
